<div *transloco="let t">
	<svg class="global-svg-defs">
		<defs>
			<pattern id="overlap-pattern" patternUnits="userSpaceOnUse" width="8" height="8">
				<rect width="8" height="8" fill="#66bb6a" opacity="0.7"></rect>
				<path d="M-2,2 l4,-4 M0,8 l8,-8 M6,10 l4,-4" style="stroke: #e65100; stroke-width: 2px" />
				<animateTransform attributeName="patternTransform" type="translate" from="0 0" to="8 0" dur="0.7s" repeatCount="indefinite" />
			</pattern>
		</defs>
	</svg>
	@if (xScale(); as scale) {
		<div class="gantt-container">
			@for (row of chartData(); track row.label; let i = $index) {
				<div class="gantt-row" [style.grid-template-columns]="gridTemplateColumns()">
					@if (showLabel()) {
						<div class="row-label" [matTooltip]="row.label" matTooltipShowDelay="300">{{ row.label }}</div>
					}
					<div class="row-chart" [style.height.px]="rowHeight()" style="min-width: 0">
						<ara-bar-chart
							[viewStartDate]="viewStartDate()"
							[viewEndDate]="viewEndDate()"
							[data]="row.segments"
							[overlaps]="row.overlaps || []"
							[xScale]="scale"
							[height]="rowHeight()"
							[barHeight]="barHeight()"
							[barTextStyle]="barTextStyle()"
							[showAxis]="shouldShowAxis(i)"
							[axisPosition]="axisPosition()"
							[parameterValueType]="parameterValueType()"
							[axisOffset]="axisOffset()"
							[allowSegmentClick]="allowSegmentClick()"
							[enableAxisDrag]="enableAxisDrag() && shouldShowAxis(i)"
							[disableAnimation]="disableAnimation()"
							(segmentClick)="handleSegmentClick($event, row, parameterValueType())"
							(dateRangeShift)="handleDateRangeShift($event)"
							(dragStart)="handleDragStart()"
							(dragEnd)="handleDragEnd()"></ara-bar-chart>
					</div>
					@if (reserveActionsSpace()) {
						<div class="gantt-actions">
							@if (showAddBtn()) {
								<button mat-icon-button aria-label="Bar action" (click)="onRowActionClick(row, parameterValueType())">
									<mat-icon [svgIcon]="icons.get('add')"></mat-icon>
								</button>
							}
						</div>
					}
				</div>
			}
		</div>
	}
</div>
